import React from 'react';
import PropTypes from 'prop-types';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';

import Button from '../button';
import Icon from '../icon';
import t from '../../i18n';
import './style.scss';

const goMessage = <FontAwesomeIcon className="default-go-msg" icon={faAngleRight} />;

@observer
export default class Pager extends React.Component {

	static propTypes = {
		itemsPerPage: PropTypes.number,
		totalCount: PropTypes.number,
		current: PropTypes.number,
		onChange: PropTypes.func,
		makeLink: PropTypes.func,
		className: PropTypes.string,
		directChange: PropTypes.bool,
		goMessage: PropTypes.any,
	};

	static defaultProps = {
		itemsPerPage: 10,
		current: 1,
		directChange: false,
		goMessage,
	};

	@observable directPage;
	@observable directPageChanged = false;

	constructor(props) {
		super(props);
		this.directPage = this.props.current;
	}

	onClick = (e, page) => {
		e.preventDefault();
		if (this.props.onChange) this.props.onChange(page);
	};

	makePageLink = (page, content, disabled, style = {}) => {
		if (this.props.makeLink) return this.props.makeLink(page, content, disabled);
		const className = (page === this.props.current ? 'active ' : ' ') + (disabled ? 'disabled ' : ' ');
		return (
			<a
				href="#"
		        key={page}
				className={className}
				style={style}
				onClick={e => this.onClick(e, page)}>
				{content || page}
			</a>
		);
	};

	onDirectChange = e => {
		const value = e.target.value;
		const clean = value.replace(/[^0-9]/g, '');
		this.directPage = clean;
		this.directPageChanged = clean.length > 0;
	};

	onDirectKey = e => {
		if (e.keyCode === 13) {
			this.submitDirectPage();
		}
	};

	submitDirectPage = () => {
		const page = parseInt(this.directPage);
		const total = Math.ceil(this.props.totalCount / this.props.itemsPerPage);
		console.log('go', page, total);
		this.directPageChanged = false;
		if (page > total) {
			this.directPage = String(total);
		}
		else {
			if (this.props.onChange) this.props.onChange(page);
		}
	};

	render() {
		const { itemsPerPage, totalCount, current, className } = this.props;

		const total = Math.ceil(totalCount / itemsPerPage);

		const _className = 'ui-pager ' + (className || '') + (totalCount <= itemsPerPage ? ' single' : '');

		// console.log('Pager render: totalCount', totalCount, itemsPerPage);

		let pager = <div className={_className}>
			{totalCount !== undefined ?
				t('total') + `: ` + totalCount
				:
				''
			}
		</div>;

		if (total > 1) {
			let range0 = current - 1;
			let range1 = current + 1;
			if (range0 <= 2) range0 = 2;
			if (range1 >= total - 1) range1 = total - 1;
			if (range0 > total - 3 && total > 3) range0 = total - 3;
			if (range1 < 4 && total > 4) range1 = 4;
			if (total <= 8) {
				range0 = 2;
				range1 = total - 1;
			}
			// console.log('range', range0, range1, pagesCount);
			const pages = [this.makePageLink(1)];
			if (range0 > 2) pages.push(<span key="pager1">...</span>);
			for (let i = range0; i <= range1; i++) {
				pages.push(this.makePageLink(i));
			}
			if (range1 < total - 1) pages.push(<span key="pager2">...</span>);
			pages.push(this.makePageLink(total));
			pager =  <div className={_className}>
				{this.makePageLink(current - 1, <FontAwesomeIcon icon={faAngleLeft}/>, current === 1, {marginLeft: -5})}
				{pages}
				{this.makePageLink(current + 1, <FontAwesomeIcon icon={faAngleRight}/>, current === total)}
				{this.props.directChange && <>
					<input
						type="text"
						className="direct-page"
						value={this.directPage}
						onChange={this.onDirectChange}
						onKeyDown={this.onDirectKey}
					/>
					{this.directPageChanged && <div className="direct-page-submit" onClick={this.submitDirectPage}>{this.props.goMessage}</div>}
				</>}
				<small className="ui-pager-total">{t('total')}: {totalCount}</small>
			</div>;
		}

		return pager;
	}

}
